module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/alerts/alerts.component.css
// module id = ./src/app/home/alerts/alerts.component.css
// module chunks = main